import { useCallback } from 'react';
import eventBus from '../utils/eventBus';

/**
 * DEPRECATED: This hook was causing race conditions and data corruption.
 * The undelivered image check is now handled properly in NavigationMenu.jsx
 *
 * Custom hook for managing undelivered images functionality
 * This is now a simple wrapper that triggers the proper implementation
 */
export const useUndeliveredImages = () => {
    const checkingUndeliveredImages = useCallback(async () => {
        console.log("[UNDELIVERED RECOVERY HOOK] Delegating to NavigationMenu implementation to prevent race conditions");

        // Emit event to trigger the proper implementation in NavigationMenu
        // This ensures only one implementation runs and avoids race conditions
        eventBus.emit('trigger_undelivered_check');

        // Add small delay to allow the event to be processed
        await new Promise(resolve => setTimeout(resolve, 100));
    }, []);

    return {
        checkingUndeliveredImages
    };
};